module.exports = __webpack_public_path__ + "static/media/esolution_logo.aa57afe4.jpeg";